import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Chart from 'react-apexcharts';
import { Card, Text, Metric } from '@tremor/react';

const apiUrlSeleccion = `${process.env.REACT_APP_API_URL}/seleccion`;

const CardGripMapSemanal = ({ sedeSeleccionada }) => {
  const [datos, setDatos] = useState([]);

  useEffect(() => {
    const obtenerDatos = async () => {
      try {
        let url = apiUrlSeleccion;
        if (sedeSeleccionada) {
          url += `?id_sede=${sedeSeleccionada}`;
        }
        const res = await axios.get(url);
        setDatos(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    obtenerDatos();
  }, [sedeSeleccionada]);

  // Agrupación por día
  const cantidadPorTipoYDia = {};
  datos.forEach((pedido) => {
    const fecha = pedido.fecha;
    if (!cantidadPorTipoYDia[fecha]) {
      cantidadPorTipoYDia[fecha] = {
        cantidad_menu: 0,
        cantidad_veggie: 0,
        cantidad_pechuga: 0,
      };
    }

    switch (pedido.tipo) {
      case 'Menu':
        cantidadPorTipoYDia[fecha].cantidad_menu += 1;
        break;
      case 'Veggie':
        cantidadPorTipoYDia[fecha].cantidad_veggie += 1;
        break;
      case 'Pechuga':
        cantidadPorTipoYDia[fecha].cantidad_pechuga += 1;
        break;
      default:
        break;
    }
  });

  // Preparar datos para el gráfico de línea
  const fechasOrdenadas = Object.keys(cantidadPorTipoYDia).sort();

  const labels = fechasOrdenadas.map((fecha) =>
    new Date(fecha + 'T00:00').toLocaleDateString('es-ES', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
    })
  );

  const dataMenu = fechasOrdenadas.map((fecha) => cantidadPorTipoYDia[fecha].cantidad_menu);
  const dataVeggie = fechasOrdenadas.map((fecha) => cantidadPorTipoYDia[fecha].cantidad_veggie);
  const dataPechuga = fechasOrdenadas.map((fecha) => cantidadPorTipoYDia[fecha].cantidad_pechuga);

  const seriesLine = [
    { name: 'Menú', data: dataMenu },
    { name: 'Veggie', data: dataVeggie },
    { name: 'Pechuga', data: dataPechuga },
  ];


  return (
    <div className="mt-6">
      {/* Tarjetas por día */}
      <div className="flex flex-wrap gap-6 mb-10">
        {fechasOrdenadas.map((fecha) => {
          const fechaFormateada = new Date(fecha + 'T00:00').toLocaleDateString('es-ES', {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
          });

          return (
            <Card
              key={fecha}
              className="w-[280px] bg-white shadow-lg hover:shadow-xl transition-all rounded-xl border-2 border-blue-200"
            >
              <Metric className="!text-lg !mb-3 !text-gray-900 !font-bold border-b-2 border-blue-100 pb-2">
                {fechaFormateada.charAt(0).toUpperCase() + fechaFormateada.slice(1)}
              </Metric>
              <div className="space-y-2">
                <div className="flex items-center justify-between bg-blue-50 px-3 py-2 rounded-lg">
                  <Text className="!text-gray-700 !font-semibold">🍽 Menú:</Text>
                  <Text className="!text-blue-700 !font-bold !text-lg">{cantidadPorTipoYDia[fecha].cantidad_menu}</Text>
                </div>
                <div className="flex items-center justify-between bg-green-50 px-3 py-2 rounded-lg">
                  <Text className="!text-gray-700 !font-semibold">🥗 Veggie:</Text>
                  <Text className="!text-green-700 !font-bold !text-lg">{cantidadPorTipoYDia[fecha].cantidad_veggie}</Text>
                </div>
                <div className="flex items-center justify-between bg-orange-50 px-3 py-2 rounded-lg">
                  <Text className="!text-gray-700 !font-semibold">🍗 Pechuga:</Text>
                  <Text className="!text-orange-700 !font-bold !text-lg">{cantidadPorTipoYDia[fecha].cantidad_pechuga}</Text>
                </div>
              </div>
            </Card>
          );
        })}
      </div>

      {/* Gráfico de línea por día */}
      <Card className="p-6 bg-white rounded-2xl shadow-xl border-2 border-blue-200">
        <Metric className="mb-6 text-gray-800 font-bold flex items-center gap-2">
          <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          Evolución diaria de pedidos
        </Metric>
        <Chart
          options={{
            chart: {
              type: 'bar',
              foreColor: '#374151',
              toolbar: { show: false },
              background: 'transparent'
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '60%',
              },
            },
            colors: ['#3b82f6', '#10b981', '#f59e0b'],
            dataLabels: {
              enabled: true,
              style: {
                colors: ['#fff'],
                fontWeight: 'bold'
              },
            },
            xaxis: {
              categories: labels,
              labels: {
                style: { colors: '#6b7280', fontWeight: 600 },
              },
            },
            yaxis: {
              labels: {
                style: { colors: '#6b7280', fontWeight: 600 },
              },
            },
            legend: {
              position: 'top',
              labels: {
                colors: ['#374151'],
              },
            },
            tooltip: {
              theme: 'light',
            },
            grid: {
              borderColor: '#e5e7eb',
            },
          }}
          series={seriesLine}
          type="bar"
          height={400}
        />
      </Card>

    </div>
  );
};

export default CardGripMapSemanal;


